import React, { Fragment, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import { x, useDown } from '@xstyled/styled-components'

import Articles from '../components/Articles'
import { fetchArticles } from '../../store/articles'
import { staticPageView, setPageType } from '../../store/app'
import { getVisitorId, getSessionId } from '../../store/article'
import WingBanners from '../components/WingBanners'
import Ad from '../components/Ad'
import {FORMATS, MAPPINGS} from '../components/AdFormats'
import ArticleFourRow from '../../templates/ArticleFourRow'
import { ArticleFourRowSkeleton as Skeleton } from '../components/Skeletons'
import NotFound from './NotFound'
import NoImage from '../../../assets/images/general/no-image.png'
import next from '../../../assets/images/icons/gallery-next.svg'
import StyledLink from '../components/ui/Link'

import TheStar from '../../../assets/images/newspapers-page/the-star.svg'
import CapeArgus from '../../../assets/images/newspapers-page/cape-argus.svg'
import WeekendCapeArgus from '../../../assets/images/newspapers-page/weekend-argus.svg'
import DailyNews from '../../../assets/images/newspapers-page/daily-news.svg'
import CapeTimes from '../../../assets/images/newspapers-page/cape-times.svg'
import TheMercury from '../../../assets/images/newspapers-page/the-mercury.svg'
import PretoriaNews from '../../../assets/images/newspapers-page/pretoria-news.svg'
import BusinessReport from '../../../assets/images/newspapers-page/business-report.svg'
import SaturdayStar from '../../../assets/images/newspapers-page/saturday-star.svg'
import IndependantSat from '../../../assets/images/newspapers-page/independent-on-saturday.svg'
import SundayTribune from '../../../assets/images/newspapers-page/sunday-tribune.svg'
import SundayIndependent from '../../../assets/images/newspapers-page/sunday-independent.svg'

const newspaperTitles = [
  {
    name: 'The Star',
    slug: 'the-star',
    logo: TheStar
  },
  {
    name: 'Cape Argus',
    slug: 'capeargus',
    logo: CapeArgus
  },
  {
    name: 'Weekend Argus',
    slug: 'weekend-argus',
    logo: WeekendCapeArgus
  },
  {
    name: 'Daily News',
    slug: 'dailynews',
    logo: DailyNews
  },
  {
    name: 'Cape Times',
    slug: 'capetimes',
    logo: CapeTimes
  },
  {
    name: 'The Mercury',
    slug: 'mercury',
    logo: TheMercury
  },
  {
    name: 'Pretoria News',
    slug: 'pretoria-news',
    logo: PretoriaNews
  },
  {
    name: 'Business Report',
    slug: 'business-report',
    logo: BusinessReport
  },
  {
    name: 'Saturday Star',
    slug: 'saturday-star',
    logo: SaturdayStar
  },
  {
    name: 'Independent on Saturday',
    slug: 'ios',
    logo: IndependantSat
  },
  {
    name: 'Sunday Tribune',
    slug: 'sunday-tribune',
    logo: SundayTribune
  },
  {
    name: 'Sunday Independent',
    slug: 'sundayindependent',
    logo: SundayIndependent
  }
]

const NewspapersPage = (props) => {
  const downMd = useDown('md')
  setPageType('section')
  useEffect(
    () => {
      if (('/' + props.section) === props.location.pathname) {
        props.staticPageView(props.location.pathname, props.visitorId, props.sessionId)
      }
    },
    [props.section]
  )
  const clickSource = 'Newspaper Page'
  return (
    <>
      <x.main px={{ sm: '20px', wAdD: props.app.wallpaperActive ? '0px' : '200px' }} mt={{ sm: '96px', lg: props.app.wallpaperActive ? '0px' : '173px' }} w='100%' maxWidth={{ sm: '1260px', wAdD: props.app.wallpaperActive ? '1220px' : '1660px' }} mx='auto'>
        <Ad isConnected={props.isConnected} adPath={props.adPath} slotId='interstitial' targeting={{ interstitial: 'interstitial' }} collapseEmptyDiv className='advert' anchor='interstitial' mapping={MAPPINGS.Interstitial} {...FORMATS.interstitial} />
        <WingBanners isConnected={props.isConnected} adPath={props.adPath} location={props.location} onSlotRenderEndedLeft={props.onSlotRenderEndedLeft} onSlotRenderEndedRight={props.onSlotRenderEndedRight} />
        <x.div maxWidth={1220} w='100%' mx='auto' mt={50}>
          {newspaperTitles.map(title => (
            <Fragment key={title.slug}>
              <x.div position='relative' w='100%' mt={50}>
                <x.h3 text='h3' borderWidth='0 0 1px 0' borderStyle='solid' borderColor='divider' pb={10} mb={20}><StyledLink to={'/' + title.slug} visitorId={props.visitorId} sessionId={props.sessionId} section={props.section} source={clickSource}><x.img src={title.logo} title={title.name} h={30} w='auto' /></StyledLink></x.h3>
                <StyledLink to={'/' + title.slug} position='absolute' top='50%' right='0' transform='translateY(-50%)' textTransform='uppercase' text='small' color={{ hover: 'red' }} display='flex' justifyContent='center' alignItems='center' flexDirection='row' visitorId={props.visitorId} sessionId={props.sessionId} section={props.section} source={clickSource}>More <x.img src={next} w='24px' h='24px' /></StyledLink>
              </x.div>
              <Articles
                {...props} fetchMoreArticles={()=>{}} section={title.slug} count={4} pageSize={4} noImage={NoImage} notFound={NotFound} component={({ articles, section, noImage, isConnected, withReadCount }) => (
                  <ArticleFourRow articles={articles} loading={Skeleton} section={section} noImage={noImage} isConnected={isConnected} withReadCount={withReadCount} visitorId={props.visitorId} sessionId={props.sessionId} />
                )}
              />
            </Fragment>
          ))}
        </x.div>
        {!downMd &&
          <x.div mt={20} mb={50} mx={-20} textAlign='center' display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
            <Ad isConnected={props.isConnected} adPath={props.adPath} collapseEmptyDiv slotId='leaderboard-bot' targeting={{ leaderboard: 'bot' }} mapping={MAPPINGS['Leaderboard']} className='advert' {...FORMATS.leaderboard} />
          </x.div>
        }
      </x.main>
    </>
  )
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchArticles, staticPageView }, dispatch)

export default withRouter(connect((state) => ({ app: state.app, articles: state.articles, visitorId: getVisitorId(state), sessionId: getSessionId(state) }), mapDispatchToProps)(NewspapersPage))
